import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const StackedBlockBodyDescription = props => {
  const { className, children, ...other } = props;
  return (
    <p className={clsx("em-c-stacked-block__desc", className)} {...other}>
      {children}
    </p>
  );
};

StackedBlockBodyDescription.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

StackedBlockBodyDescription.defaultProps = {
  className: "",
  children: null
};

export default StackedBlockBodyDescription;
